import { useMediaQuery } from '@chakra-ui/react';

export function useIsWiderThan940px() {
  return useMediaQuery('(min-width: 940px)');
}
